import { render } from "./ConstellationCalculator.vue?vue&type=template&id=a46fc3cc&scoped=true"
import script from "./ConstellationCalculator.vue?vue&type=script&lang=js"
export * from "./ConstellationCalculator.vue?vue&type=script&lang=js"

import "./ConstellationCalculator.vue?vue&type=style&index=0&id=a46fc3cc&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46fc3cc"],['__file',"resources/js/components/ConstellationCalculator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a46fc3cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a46fc3cc', __exports__)) {
    api.reload('a46fc3cc', __exports__)
  }
  
  module.hot.accept("./ConstellationCalculator.vue?vue&type=template&id=a46fc3cc&scoped=true", () => {
    api.rerender('a46fc3cc', render)
  })

}


export default __exports__